import { useState } from 'react';
import { S } from './Carousel2_2.style';

export const Carousel2Browser = () => {
  const [imgIdx, setImgIdx] = useState(0);

  const imageList2 = [
    {
      src: '/assets/images/profile/leader1.png',
      name: '김기현 CEO',
      education: '성균관대 경영학/한양대 경영학(Ph.D.)',
      career1: 'DAMA(국제 데이터매니지먼트협회) 한국 대표',
      career2: '녹현리서치㈜ 대표이사',
      career3: '한림국제대학원대학교 교수(데이터 매니지먼트)',
      career4: '삼정KPMG 전략컨설팅본부 이사',
      career5: '삼성서울병원 정보전략실 책임',
      career6: '삼성 오픈타이드 시니어매니저',
    },
    {
      src: '/assets/images/profile/leader2.png',
      name: '신연성 CTO',
      education: '포항공대 산업공학',
      career1: '㈜앤서 CTO',
      career2: 'DAMA Korea 이사',
      career3: '㈜크래프트이더 연구소장',
      career4: '이더리움기업연합 한국지사 연구소장',
    },
    {
      src: '/assets/images/profile/leader3.png',
      name: '조윤경 CFO',
      education: '북경대 역사학',
      career1: '녹현리서치 전략기획실장',
      career2: 'DAMA Korea 이사',
      career3: 'TV조선 기자',
      career4: '뉴스토마토 기자',
      career5: 'KB증권 해외파생상품 영업(농산물)',
      career6: 'Calyon Bank 자본시장 영업',
    },
    // {
    //   src: '/assets/images/profile/leader4.png',
    //   name: '이봉석 COO',
    //   education: '서울대 토목공학/도쿄대 도시공학 박사',
    //   career1: '노무라종합연구소 팀장',
    //   career2: 'DAMA Korea 이사',
    //   career3: '삼정KPMG 부동산본부 이사',
    //   career4: '삼성물산 건설부문 부장',
    //   career5: 'Inpact G.C.F 컨설턴트',
    //   career6: '일본 토지종합연구소 조사부 연구원',
    // },
    {
      src: '/assets/images/profile/leader5.png',
      name: '박성필 CIO',
      education: '성균관대 빅데이터학 석사',
      career1: '㈜앤서 개발이사',
      career2: '㈜디에스앤텍 연구소 차장',
    },
    // {
    //   src: '/assets/images/profile/leader6.png',
    //   name: '김일숙 CDO',
    //   education: '한국외대 정치외교학/중앙대 GHRD 석사',
    //   career1: '대통령비서실 디지털소통 행정관 (3급)',
    //   career2: 'JTBC 디지털콘텐트 팀장 (부장)',
    //   career3: 'SBS 미디어서비스 담당 (부장)',
    //   career4: 'CBSi 노컷뉴스 런칭 팀장 (차장)',
    // },
    {
      src: '/assets/images/profile/leader7.png',
      name: '조환익 감사',
      education: '서울대/NYU/한양대 경영학(Ph.D.)',
      career1: '유니슨㈜ 회장',
      career2: '녹현리서치㈜ 회장',
      career3: '한국전력 사장',
      career4: 'KOTRA 사장',
      career5: '수출보험공사 사장',
      career6: 'KIAT(전 산업기술재단) 설립자',
      career7: '제6대 산업자원부 차관',
    },
    {
      src: '/assets/images/profile/leader8.png',
      name: '남재작 사외이사',
      education: '경북대 농화학/경북대 분석화학(Ph.D.)',
      career1: '한국정밀농업연구소 소장',
      career2: '농어업농어촌특별위원회 위원',
      career3: '농림식품과학기술위원회 위원',
      career4: 'UN 기후변화전문가',
      career5: 'KOICA 농업ODA 전문가',
      career6: '한국농업기술진흥원 기획조정실장',
      career7: '농촌진흥청 농업과학원 농업연구사',
    },
  ];

  const current = imageList2[imgIdx];

  const handlePrev = () => {
    if (imgIdx > 0) {
      setImgIdx(imgIdx - 1);
    }
  };

  const handleNext = () => {
    if (imgIdx < imageList2.length - 1) {
      setImgIdx(imgIdx + 1);
    }
  };

  const progress = ((imgIdx + 1) / imageList2.length) * 100;

  return (
    <S.Container>
      <S.Card>
        <img
          src={current.src}
          alt={current.name}
          style={{ borderRadius: '8px' }}
        />
        <S.Info>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <S.Name>{current.name}</S.Name>
            <S.Education>{current.education}</S.Education>
          </div>
          <S.Career>
            {[
              current.career1,
              current.career2,
              current.career3,
              current.career4,
              current.career5,
              current.career6,
              current.career7,
            ]
              .filter(Boolean)
              .map((c, i) => (
                <div key={i}>{c}</div>
              ))}
          </S.Career>
        </S.Info>
      </S.Card>

      {/* 진행 바 */}
      <S.ProgressBarWrapper>
        <S.ProgressBar style={{ width: `${progress}%` }} />
      </S.ProgressBarWrapper>

      {/* 화살표 */}
      <S.ArrowWrapper>
        <img
          src="/assets/images/arrow/ArrowWithCircleLeft.svg"
          onClick={handlePrev}
        />
        <img
          src="/assets/images/arrow/ArrowWithCircleRight.svg"
          onClick={handleNext}
        />
      </S.ArrowWrapper>
    </S.Container>
  );
};

export default Carousel2Browser;
